import { getConfig } from "./config.utils";

const config = getConfig();
export const BRAND_WEBSITE = config.BRAND_WEBSITE || "";
export const DASH_URL = config.DASH_URL || "";
export const QUOTE_BFF = config.QUOTE_BFF || "";
export const QUOTE_API = config.QUOTE_API || "";
export const DASH_API = config.DASH_API || "";
export const GATEWAY_API = config.GATEWAY_API || "";
